// =======================
// src/paginas/analise/autorizarCadastro/autorizaCadastro.js
// =======================
import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Paper,
  TextField,
  Pagination,
  InputAdornment,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { Link } from "react-router-dom";
import axios from "axios";
import { api } from "@api/api";
import TransicaoPagina from "../../../componentes/comuns/TransicaoPagina";

const blueTheme = {
  primary: "#1976d2",
  primaryLight: "#63a4ff",
  primaryDark: "#004ba0",
  secondary: "var(--sear-superficie-azul, #e3f2fd)",
  background: "var(--sear-superficie-azul, #f5f9ff)",
  text: "var(--sear-texto, #212121)",
  textSecondary: "var(--sear-texto-secundario, #757575)",
  white: "#ffffff",
  divider: "var(--sear-borda, #e0e0e0)",
};

export default function CadastroPendentesPage() {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [cadastrosPendentes, setCadastrosPendentes] = useState([]);
  const itemsPerPage = 9;

  useEffect(() => {
    axios
      .get(api.pending(), {
        withCredentials: true, // essencial para enviar o cookie JWT
      })
      .then((response) => setCadastrosPendentes(response.data))
      .catch((error) =>
        console.error("Erro ao carregar cadastros pendentes:", error),
      );
  }, []);

  const filteredCadastros = cadastrosPendentes.filter((cadastro) =>
    cadastro.nome?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const paginatedCadastros = filteredCadastros.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const totalPages = Math.ceil(filteredCadastros.length / itemsPerPage);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <TransicaoPagina variante="navegacao">
      <Box
        sx={{
          backgroundColor: blueTheme.background,
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth={false} disableGutters>
          <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <Typography
                variant="h5"
                component="h4"
                sx={{
                  fontWeight: "bold",
                  color: blueTheme.primary,
                }}
              >
                Cadastros Pendentes
              </Typography>

              <TextField
                variant="outlined"
                placeholder="Pesquisar..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: blueTheme.primary }} />
                    </InputAdornment>
                  ),
                  sx: { borderRadius: 3 },
                }}
                sx={{ minWidth: 300 }}
              />
            </Box>

            {filteredCadastros.length === 0 ? (
              <Box
                sx={{
                  textAlign: "center",
                  py: 4,
                  backgroundColor: blueTheme.secondary,
                  borderRadius: 3,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ color: blueTheme.textSecondary }}
                >
                  Não existem pendências de autorização.
                </Typography>
              </Box>
            ) : (
              <>
                <Grid container spacing={3}>
                  {paginatedCadastros.map((cadastro) => (
                    <Grid item xs={12} sm={6} md={4} key={cadastro.id}>
                      <Card
                        component={Link}
                        to={`/aprovar-cadastro/${cadastro.tipo}/${cadastro.id}`}
                        sx={{
                          textDecoration: "none",
                          transition: "transform 0.3s, box-shadow 0.3s",
                          "&:hover": {
                            transform: "translateY(-5px)",
                            boxShadow: 4,
                          },
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          borderRadius: 3,
                          borderLeft: `4px solid ${blueTheme.primary}`,
                          backgroundColor: "var(--sear-superficie, #ffffff)",
                        }}
                      >
                        <CardContent sx={{ flexGrow: 1 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: "bold",
                              color: blueTheme.primary,
                              mb: 1,
                            }}
                          >
                            {cadastro.nome}
                          </Typography>
                          <Box
                            sx={{
                              backgroundColor: blueTheme.secondary,
                              display: "inline-block",
                              px: 1.5,
                              py: 0.5,
                              borderRadius: 3,
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{
                                color: blueTheme.primary,
                                fontWeight: "medium",
                              }}
                            >
                              {cadastro.tipo === "escola"
                                ? "Escola"
                                : "Mantenedora"}
                            </Typography>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>

                <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                    sx={{
                      "& .MuiPaginationItem-root": {
                        color: blueTheme.primary,
                      },
                      "& .Mui-selected": {
                        backgroundColor: `${blueTheme.primary} !important`,
                        color: blueTheme.white,
                      },
                    }}
                  />
                </Box>
              </>
            )}
          </Paper>
        </Container>
      </Box>
    </TransicaoPagina>
  );
}
